import { htmlToSlate, htmlToSlateConfig, slateToHtml, slateToHtmlConfig } from "@slate-serializers/html";
import { Element as DomElement } from "domhandler";
import { getAttributeValue, getText } from "domutils";
import parse from "style-to-object";

/*
 * Rich Text supported features:
 * - Bold, italics, underline
 * - Font size
 * - Links
 *
 * Example HTML:
 * <p>This is <strong>bold</strong> text and <span style="font-size: 20px;">big</span> text</p>
 * <p></p>
 * <p>This is another paragraph</p>
 *
 * Equivalent Slate JSON:
 * [
 *   { type: "p", children: [
 *     { text: "This is " },
 *     { text: "bold", bold: true },
 *     { text: " text and " },
 *     { text: "big", fontSize: "20px" },
 *     { text: " text" }
 *   ] },
 *   { type: "p" },
 *   { type: "p", children: [
 *     { text: "
 *   ] }
 * ]
 */

const isDebugging = false;

export const emptyContentHtml = "<p></p>";

/**
 * See: https://thompsonsj.github.io/slate-serializers-demo/slate-to-html/docs
 * @param {Object} value
 * @returns {string}
 */
export const convertSlateToHtml = value => {
    const htmlValue = slateToHtml(value || [], {
        ...slateToHtmlConfig,
        elementTransforms: {
            ...slateToHtmlConfig.elementTransforms,
            link: ({ node, children = [] }) => new DomElement("a", {
                href: node.url,
                target: "_blank",
                rel: "noreferrer",
                style: "font-weight: bold; text-decoration: underline;"
            }, children)
        },
        markTransforms: {
            ...slateToHtmlConfig.markTransforms,
            fontSize: ({ node }) => new DomElement("span", {
                style: `font-size: ${node.fontSize}`
            })
        }
    });

    // Testing: convert JSON to HTML and then back
    // Check in console that the final JSON matches the original
    if (isDebugging) {
        console.log("---SLATE TO HTML---");
        console.log(JSON.stringify(value));
        console.log(htmlValue);
        convertHtmlToSlate(htmlValue);
    }

    return htmlValue;
};

/**
 * See: https://thompsonsj.github.io/slate-serializers-demo/html-to-slate/docs
 * @param {string} value
 * @returns {Array}
 */
export const convertHtmlToSlate = value => {
    const slateValue = htmlToSlate(value || "<p></p>", {
        ...htmlToSlateConfig,
        textTags: {
            ...htmlToSlateConfig.textTags,
            span: el => {
                const fontSize = pullStyleValue(el, "font-size");
                return {
                    fontSize,
                    text: getText(el)
                };
            }
        }
    });

    if (isDebugging) {
        console.log("---HTML TO SLATE---");
        console.log(value);
        console.log(JSON.stringify(slateValue));
    }

    return slateValue;
};

const pullStyleValue = (el, attribute) => {
    const styleString = getAttributeValue(el, "style");
    const parsed = styleString && parse(styleString);
    return parsed?.[attribute] ?? null;
};
